import {
  faInfoCircle,
  faPlus,
  faRedo,
  faSearch,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import moment from "moment";
import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import { fetchProperties } from "../../helpers/api/condominium";
import {
  addStallManual,
  generateAutoStalls,
  getAllStalls,
} from "../../helpers/api/parking";
import {
  ERROR_RESPONSE,
  SUCCESS_RESPONSE,
} from "../../helpers/codeResponses/codes";
import { FetchError } from "../../helpers/errors/FetchError";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import ButtonIcon from "../common/ButtonIcon";
import FalconCardHeader from "../common/FalconCardHeader";
import Flex from "../common/Flex";
import PageHeader from "../common/PageHeader";
import FullPagination from "../common/pagination/FullPagination";
import SelectPropertyListItem from "../common/SelectPropertyListItem";
import SupportLink from "../root/support/components/SupportLink";
import {
  If,
  isIterableArray,
  Message,
  Or,
  PreloadState,
} from "../UI/preloading/PreloadState";
import { Toast } from "../UI/toast/Toast";

const Stalls = () => {
  const { id } = useParams();

  const history = useHistory();

  const { selectedCondominium } = useSelector((state) => state.condominium);

  const [params, setParams] = useState({
    parking: id,
    search: "",
    available: 2,
  });

  const [paramos] = useState({
    condominiumId: selectedCondominium,
  });

  const { role } = useSelector((state) => state.auth.user);

  const [collapseOne, collapseOneOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  const {
    data,
    error,
    isLoading,
    meta,
    mutate,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(getAllStalls, params);

  const prop = useSWRFetchPagination(fetchProperties, paramos);

  const [submitting, setSubmitting] = useState(false);
  const [submittingAdd, setsubmittingAdd] = useState(false);

  const [textSearch, setTextSearch] = useState("");
  const [quantity, setQuantity] = useState(1);

  const [selectedProperty, setSelectedProperty] = useState(null);

  const generateStalls = () => {
    setSubmitting(true);
    generateAutoStalls(selectedCondominium, id, quantity)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.ADDED_TO_QUEUE) {
          Toast.fire({
            type: "success",
            title: `Puestos generados exitosamente.`,
          });
          history.push(`/dashboard/parking/${id}/stalls`);
        }
      })
      .catch((error) => {
        if (error instanceof FetchError) {
          const {
            data: { code },
          } = error;
          if (code === ERROR_RESPONSE.BAD_REQUEST) {
            Toast.fire({
              type: "error",
              title: `Ya se han generado los puestos anteriormente.`,
            });
          } else {
            handleErrorMessage(error);
          }
        }
      })
      .finally(() => {
        setSubmitting(false);
        setQuantity(1);
        setVisible(false);
      });
  };

  const renderPropertiesItems = () =>
    prop.data?.map((property) => (
      <SelectPropertyListItem
        key={property.id}
        onSelect={setSelectedProperty}
        selected={selectedProperty}
        propertyId={property?.id}
        name={`${property?.user?.data?.firstname} ${property?.user?.data?.lastname}`}
        username={property?.user?.username}
        dni={property?.user?.data?.dni}
        alternativeName="propietario"
      />
    ));

  const handleModalAdd = () => (
    <Modal className="modal-lg" isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Registro de puesto adicional</ModalHeader>
      <ModalBody className="bg-light">
        <Row>
          <Col tag={FormGroup}>
            <Label>Seleccione un propietario de la lista</Label>
            <PreloadState
              cond={isIterableArray(prop.data)}
              loading={prop.isLoading}
            >
              <Or value={true}>{renderPropertiesItems()}</Or>
              <Or value={false}>
                <Alert color="info" className="fs--1">
                  <p className="mb-0">No hay propietarios para mostrar.</p>
                </Alert>
              </Or>
            </PreloadState>
            {isIterableArray(prop.data) && !prop.isLoading && (
              <>
                <hr />
                <FullPagination
                  nextPage={prop.handler.nextPage}
                  prevPage={prop.handler.previousPage}
                  goToPage={prop.handler.goToPage}
                  meta={prop.meta}
                  className={"shadow-none"}
                  posText={"propietarios"}
                  perPage={prop.handler.perPage}
                />
              </>
            )}
            {!selectedProperty && (
              <span
                className={classNames(
                  "text-danger d-inline-block fs--1 font-weight-normal d-block"
                )}
              >
                Debes seleccionar un propietario
              </span>
            )}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => collapseOneOpen(false)}>
          Cancelar
        </Button>
        <Button
          data-testid="submit-button"
          color="primary"
          type="submit"
          disabled={!selectedProperty || submittingAdd}
          onClick={addStall}
        >
          Agregar puesto adicional{" "}
          {submittingAdd && <Spinner size="sm" color="white" />}
        </Button>
      </ModalFooter>
    </Modal>
  );

  const handleModalGenerate = () => (
    <Modal className="modal-lg" isOpen={visible} data-testid="modal">
      <ModalHeader>Generar puestos</ModalHeader>
      <ModalBody className="bg-light">
        <Row>
          <Col tag={FormGroup}>
            <Label>Puestos por propiedad</Label>
            <Input
              type="number"
              placeholder="Ingrese los puestos por propietario..."
              max={10}
              min={1}
              value={quantity}
              onChange={({ target }) => setQuantity(target.value)}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => setVisible(false)}>
          Cancelar
        </Button>
        <Button
          data-testid="submit-button"
          color="primary"
          type="submit"
          disabled={!quantity || submitting}
          onClick={() => {
            generateStalls();
          }}
        >
          Generar puestos {submitting && <Spinner size="sm" color="white" />}
        </Button>
      </ModalFooter>
    </Modal>
  );

  const addStall = () => {
    setsubmittingAdd(true);
    addStallManual(id, selectedProperty)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.CREATED) {
          Toast.fire({
            type: "success",
            title: `Puesto generado exitosamente.`,
          });
          mutate();
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => {
        setsubmittingAdd(false);
        collapseOneOpen(false);
        setSelectedProperty(null);
      });
  };

  return (
    <>
      <PageHeader
        title="Puestos"
        titleTag="h2"
        description={
          "Si necesitas ayuda comunicanos, nuestra finalidad es ayudar a los usuarios para que puedan resolver inconvenientes."
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <Card>
        <PreloadState
          loading={submitting}
          message={submitting && "Generando puestos..."}
        >
          <>
            <FalconCardHeader title="Puestos">
              <Row>
                <Col>
                  <Row>
                    <Col tag={Flex} align="center" justify="between">
                      <ButtonIcon
                        color="falcon-default"
                        className="mr-2"
                        onClick={() => history.push("/dashboard/parking")}
                        icon={faUndo}
                      >
                        Volver a estacionamientos
                      </ButtonIcon>
                      <If cond={["manager"]}>
                        <div value={role}>
                          {!isLoading && data.length === 0 && (
                            <ButtonIcon
                              color="light"
                              className="mr-2"
                              iconClassName="mr-2"
                              onClick={() => {
                                setVisible(true);
                                setQuantity(1);
                              }}
                              icon={faRedo}
                            >
                              Generar puestos
                            </ButtonIcon>
                          )}
                          <ButtonIcon
                            color="falcon-default"
                            onClick={() => collapseOneOpen(true)}
                            icon={faPlus}
                          >
                            Agregar puestos
                          </ButtonIcon>
                        </div>
                      </If>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="d-flex mt-2">
                      <Input
                        type="select"
                        value={params.available}
                        className="mr-2"
                        onChange={({ target }) =>
                          setParams((prev) => ({
                            ...prev,
                            available: target.value,
                          }))
                        }
                      >
                        <option value={2}>Todos</option>
                        <option value={1}>Disponibles</option>
                        <option value={0}>Ocupados</option>
                      </Input>
                      <Input
                        type="text"
                        value={textSearch}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            const term = event.target.value.trim();
                            setTextSearch(term);
                            setParams((prev) => ({
                              ...prev,
                              search: term || null,
                            }));
                          }
                        }}
                        onChange={(event) => {
                          const value = event.target.value;
                          setTextSearch(value);
                          if (!value.trim()) {
                            setParams((prev) => ({ ...prev, search: null }));
                          }
                        }}
                        placeholder="Buscar por puesto, inmueble, nombre, usuario, cédula o correo..."
                        className="search-input mr-2"
                      />
                      <ButtonIcon
                        color="falcon-default"
                        icon={faSearch}
                        className="text-nowrap"
                        onClick={() => {
                          const term = textSearch.trim();
                          setTextSearch(term);
                          setParams((prev) => ({
                            ...prev,
                            search: term || null,
                          }));
                        }}
                      >
                        Buscar
                      </ButtonIcon>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FalconCardHeader>
            <CardBody
              className={classNames("fs--1", { "p-0": isIterableArray(data) })}
            >
              <PreloadState loading={isLoading} cond={isIterableArray(data)}>
                <Or value={true}>
                  <Table responsive className="mb-0">
                    <thead>
                      <tr>
                        <th width="10%" className="align-middle text-center">
                          Puesto
                        </th>
                        <th className="align-middle text-center">
                          ID | Propietario
                        </th>
                        <th width="10%" className="align-middle text-center">
                          Estado
                        </th>
                        <th className="align-middle text-center">
                          Fecha de creación
                        </th>
                        <If cond={["property", "safety"]}>
                          <th value={role} className="align-middle text-center">
                            Opciones
                          </th>
                        </If>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map(
                        ({
                          property_parking_id,
                          available,
                          acronym,
                          created_at,
                          property: {
                            id,
                            user: {
                              data: { dni, firstname, lastname },
                            },
                          },
                        }) => (
                          <tr key={property_parking_id}>
                            <td className="text-center font-weight-bold align-middle">
                              {acronym}
                              {property_parking_id}
                            </td>
                            <td className="align-middle">
                              <Flex
                                className="flex-column"
                                align="center"
                                justify="center"
                              >
                                {dni ? (
                                  <b>
                                    {id} | {dni?.charAt(0)}
                                    <NumberFormat
                                      displayType="text"
                                      thousandSeparator
                                      value={dni?.substring(1, 30)}
                                    />
                                  </b>
                                ) : (
                                  <b> {id} | DNI no registrado</b>
                                )}
                                <p className="mb-0">
                                  {firstname} {lastname}
                                </p>
                              </Flex>
                            </td>
                            <td className="align-middle text-center">
                              {available ? (
                                <Badge color="soft-success" pill>
                                  Disponible
                                </Badge>
                              ) : (
                                <Badge color="soft-danger" pill>
                                  Ocupado
                                </Badge>
                              )}
                            </td>
                            <td className="align-middle text-center">
                              {moment(created_at).format("DD/MM/YYYY")}
                            </td>
                            <If cond={["property", "safety"]}>
                              <Or value={role}>
                                <td className="align-middle d-flex align-items-center justify-content-center">
                                  <UncontrolledDropdown
                                    direction="left"
                                    className="d-inline-block ml-2"
                                  >
                                    <DropdownToggle
                                      color="falcon-default"
                                      size="sm"
                                    >
                                      <FontAwesomeIcon icon="ellipsis-h" />
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                      <DropdownItem
                                        onClick={() =>
                                          history.push(
                                            `/dashboard/parking/stalls/${property_parking_id}`
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon
                                          className="mr-2"
                                          icon={faInfoCircle}
                                        />
                                        Ver detalles
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td>
                              </Or>
                            </If>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </Or>
                <Or value={false} cond={!!error}>
                  <Message
                    className="p-3"
                    value={false}
                    color="info"
                    icon={faInfoCircle}
                  >
                    No hay puestos para mostrar.
                  </Message>
                  <Message
                    className="p-3"
                    value={true}
                    color="danger"
                    icon={faInfoCircle}
                  >
                    Ha ocurrido un error.
                  </Message>
                </Or>
              </PreloadState>
            </CardBody>
            {isIterableArray(data) && !isLoading && (
              <CardFooter className="border-top">
                <FullPagination
                  nextPage={nextPage}
                  prevPage={previousPage}
                  goToPage={goToPage}
                  meta={meta}
                  className={"shadow-none"}
                  posText={"puestos"}
                  perPage={perPage}
                />
              </CardFooter>
            )}
            {handleModalAdd()}
            {handleModalGenerate()}
          </>
        </PreloadState>
      </Card>
    </>
  );
};

export default Stalls;
